import { Controller } from "@hotwired/stimulus";
import { buildUploadComponent, filesCountChangedEventName } from '../../scripts/fileUpload';
import { viewOrEditFormConnectedEventName } from "../ViewOrEditForm/ViewOrEditFormController";
import "./ImageEditor.scss";

export default class ImageEditorController extends Controller {
    static targets = [
        "photoUploader",
        "minFiles",
        "maxFiles",
        "filesCount"
    ];

    readonly photoUploaderTarget!: HTMLElement;
    readonly minFilesTarget!: HTMLInputElement;
    readonly maxFilesTarget!: HTMLInputElement;
    readonly filesCountTarget!: HTMLInputElement;

    connect() {
        this.replaceMinFilesAndMaxFilesVariablesInValidationErrorMessages();

        this.element.addEventListener(filesCountChangedEventName, this.onPhotosCountChanged.bind(this), {});

        this.element.addEventListener(viewOrEditFormConnectedEventName, () => {
            buildUploadComponent($(this.photoUploaderTarget));
        });
    }

    replaceMinFilesAndMaxFilesVariablesInValidationErrorMessages() {
        const attributeNamesWithValidationMessage = [
            "data-val-assertthat",
            "data-val-assertthata"
            // when more C# validation attributes are present, continue with "data-val-assertthatb", "data-val-assertthatc", etc
        ];
        attributeNamesWithValidationMessage.forEach(attributeNameWithValidationMessage => {
            const validationMessage = this.filesCountTarget.getAttribute(attributeNameWithValidationMessage);
            if (validationMessage) {
                this.filesCountTarget.setAttribute(attributeNameWithValidationMessage, validationMessage
                    .replace("$MinFiles", this.minFilesTarget.value)
                    .replace("$MaxFiles", this.maxFilesTarget.value)
                );
            }
        });
    }

    onPhotosCountChanged(event: CustomEventInit) {
        const photosCount = event.detail as number;
        this.filesCountTarget.value = `${photosCount}`;

        this.refreshFormValidation();
    }

    refreshFormValidation() {
        const form = $("form", this.element);
        if (form) form.valid();
    }
}